import { render, staticRenderFns } from "./Avataars.vue?vue&type=template&id=4f36d378"
import script from "./Avataars.vue?vue&type=script&lang=js"
export * from "./Avataars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports